import { Errors, Paging } from './generic';

export class DocumentRequest {
    document?: Document;
    documentExists?: boolean;
}

export class DocumentResponse {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    documents?: Documents[] = [];
    paging?: Paging;
    errors?: Errors;
}

// used for document upload
export class Document {
    entityType?: string;
    entityNumber?: string;
    facility?: string;
    businessUnit?: string;
    documentDetails?: DocumentDetails[] = []; 
    locnClass?: string;
    itemId?: number;
}

export class Documents {
    entityType?: string;
    entityNumber?: string;
    facilityId?: number;
    customerId?: number;
    businessUnitId?: number;
    documentId?: number;
    entityId?: number;
    documentDetails?: DocumentDetails[] = [];
    id?: string;
    contentType?: string;
    content?: string;
}

export class DocumentDetails {
    documentType?: string;
    documentName?: string;
    documentContent?: string;
    active?: boolean;
    documentDetailsId?: number;
    edmDocId?: string;
}
